import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SourcingCommonFilter from "../../../../Components/Filter/Sourcing/SourcingCommonFilter";

import { SearchField } from "../../../../Components/formElements/SearchField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../../Components/ChatBox/ChatBox";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import ReverseTimer from "../../../../Components/TableReverseTimer/ReverseTimer";
import { formatDateTime } from "../../../../common/Validations";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  addauctionNr,
  getEauction,
} from "../../../../redux/feature/supplier_app/eauctionSlice";

const SupplierRevAuctionHistory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  localStorage.setItem("menu", "eAuction");
  localStorage.setItem("submenu", "Reverse Auction History");

  let customerData = useSelector((state) => state.eauctionSlice.eauction);
  let customerTable = useSelector(
    (state) => state.eauctionSlice.eauction.pagination,
  );

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: page,
      per_page: getNewPerPage,
    };
    dispatch(getEauction(obj));
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getEauction(obj));
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getEauction(obj));
  };

  useEffect(() => {
    let obj = {
      queryName: "getReverseAuctionList",
      module: "",
      page: 1,
      per_page: 10,
    };
    dispatch(getEauction(obj));
  }, [dispatch]);

  useEffect(() => {
    // Filter to show only expired/completed auctions. Status (kept fresh by the
    // backend's periodic auto-close sweep) is the source of truth -- NOT closingDateTime
    // alone, since that can be briefly stale right after an extension and would
    // wrongly pull a still-live (extended) auction into history.
    if (customerData?.data) {
      const expiredAuctions = customerData.data.filter((auction) => {
        if (auction.deliveryStatusHeader === "Closed" || auction.auctionStatus === "Ended") {
          return true;
        }
        if (auction.deliveryStatusHeader == null && auction.auctionStatus == null && auction.closingDateTime) {
          return new Date(auction.closingDateTime) <= new Date();
        }
        return false;
      });
      setData(expiredAuctions);
    }
  }, [customerData]);

  const auctionDetail = (row) => {
    dispatch(addauctionNr(row?.documentNumber));
    navigate(Constants.EAUCTION_SUPPLIER_AUCTION_DETAILS);
  };

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row?.userId)}
              title={row?.userId ? "Chat With the User" : "No User Found"}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Auction Number",
      cell: (row) => (
        <button className="btnInfo" onClick={() => auctionDetail(row)}>
          {row.auctionNr || "-"}{" "}
        </button>
      ),
      selector: (row) => row.auctionNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "RFQ Number",
      selector: (row) => row.rfqNr || "--",
      sortable: true,
      cell: (row) => <button className="btnInfo">{row.rfqNr || "-"} </button>,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.auctionStatus} />
        </>
      ),
      width: "130px",
    },
    {
      name: "Auction Type",
      cell: (row) => (
        <TableStatusField status={row.auctionType} />
      ),
      selector: (row) => row.auctionType || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Start Time",
      selector: (row) => formatDateTime(row.openingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "End Time",
      selector: (row) => formatDateTime(row.closingDateTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Remaining Time",
      cell: (row) => (
        <>
          <ReverseTimer
            closingDateTime={row.closingDateTime}
            openingDateTime={row.openingDateTime}
            isClosed={true}
          />
        </>
      ),
      sortable: true,
      width: "270px",
    },
    {
      name: "Auction Title",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionTitle}</span>
      ),
      selector: (row) => row.auctionTitle || "--",
      sortable: true,
      width: "130px",
    },
  ];

  const [chatId, setChatId] = useState(null);
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Auction List History</h2>
                <p className="subText">
                  Lists of Auction List History and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AL</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Auction List History</span>
                      <span className="subHeaderTitle">
                        View of Auction List History and Status
                      </span>
                    </Col>

                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={() => {
                        //   alert("asd");
                        // }}
                      >
                        <i className="bi bi-plus-lg"></i> Create Auction
                      </button>
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        // columns={getItemLevelColumns}
        // data={getItemLevelData}
        // title={getModalTitle}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default SupplierRevAuctionHistory;
